{
  "version": 1,
  "asset_id": "df36e1c6-9766-4488-b3c0-4d6bd329241b",
  "project_id": "a3729fa2-e85b-4f5b-84b2-0934e880c580",
  "url": "/__l5e/assets-v1/df36e1c6-9766-4488-b3c0-4d6bd329241b/palworld-dawn-of-palpagos-booster-box-dark.jpg",
  "r2_key": "a/v1/a3729fa2-e85b-4f5b-84b2-0934e880c580/df36e1c6-9766-4488-b3c0-4d6bd329241b/palworld-dawn-of-palpagos-booster-box-dark.jpg",
  "original_filename": "palworld-dawn-of-palpagos-booster-box-dark.jpg",
  "size": 1219295,
  "content_type": "image/png",
  "created_at": "2026-09-06T19:00:51Z"
}
